import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import QrCodeWithLogo from 'qrcode-with-logos';
import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { ViewQrCodeParams } from './view-qr-code-modal.service';


@Component({
  templateUrl: './view-qr-code-modal.component.html',
  styleUrls: ['./view-qr-code-modal.component.scss']
})
export class ViewQrCodeModalComponent implements OnInit {

  private qrCodeWithLogo: QrCodeWithLogo;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ViewQrCodeParams,
    private readonly translationLoaderService: FuseTranslationLoaderService
  ) {
    this.translationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public async ngOnInit(): Promise<void> {
    this.qrCodeWithLogo = new QrCodeWithLogo({
      content: this.data.qrCode,
      width: 265,
      nodeQrCodeOptions: {
        margin: 0,
        errorCorrectionLevel: 'H'
      },
      image: document.getElementById('qr-code-img') as HTMLImageElement,
      logo: {
        src: '/assets/images/logos/f_logo_azul.png'
      }
    });

    await this.qrCodeWithLogo.toImage();
  }

  public async downloadQrCode(): Promise<void> {
    this.qrCodeWithLogo.downloadImage(`${this.data.fileName || 'qr-code'}-${this.data.qrCode}.png`);
  }
}
